import { useGetUserInfoQuery } from 'modules/User/graphql/getUserByEmail.types'
import { useOktaAuth } from '@okta/okta-react'
import { Abilities, User as GQLUser, UserRole } from '../../shared/__gql-types'

export class User {
  id: string
  email: string
  first_name: string
  last_name: string
  space_id: string | null
  zoneId: number
  label_id: string | null
  is_external: boolean
  is_active: boolean
  allowedZoneIds: string[]
  role: UserRole
  abilities: Abilities
  country_code: string

  constructor(userFields: Partial<GQLUser>, allowedZoneIds: string[]) {
    this.id = userFields.id ?? ''
    this.email = userFields.email ?? ''
    this.first_name = userFields.first_name ?? ''
    this.last_name = userFields.last_name ?? ''
    this.space_id = userFields.space_id ?? null

    this.label_id = userFields.label_id ?? null
    this.zoneId = parseInt(userFields.label_id ?? '0') // label_id is mandatory. will be fixed after refactoring the spaces feature
    this.is_active = userFields.is_active ?? false
    this.is_external = userFields.is_external ?? false
    this.allowedZoneIds = allowedZoneIds
    this.country_code = userFields.country_code ?? ''
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.role = userFields.role!
    this.abilities = userFields.abilities || {}
  }

}

export const useCurrentUser = () => {
  const { authState } = useOktaAuth()
  const email = authState?.idToken?.claims?.email ?? ''

  const { data, loading: loadingUser, error } = useGetUserInfoQuery({
    skip: !email,
    variables: {
      email: email
    }
  })

  const loading = !authState || loadingUser
  if (data === undefined) return { loading, error }
  const { user, spaces } = data
  const isSpaceUser = user.space_id !== null
  const allowedZoneIds = isSpaceUser
    ? spaces
      .find(s => s.id === user.space_id)
      ?.labels.map(l => l.id) ?? []
    : user.label_id ? [user.label_id] : []

  return {
    user: new User(data.user, allowedZoneIds),
    loading,
    error
  }
}
